import { render } from "./CIS-Resource-Newsletter.vue?vue&type=template&id=386f22aa&scoped=true"
import script from "./CIS-Resource-Newsletter.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Newsletter.vue?vue&type=script&lang=js"

import "./CIS-Resource-Newsletter.vue?vue&type=style&index=0&id=386f22aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386f22aa"]])

export default __exports__